module.exports = function getResource(label, vars = []) {
    let resources = {
        happening: 'Happening at Sephora',
        find: 'Find a Sephora'
    };

    return resources[label];
};
